import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Thomas de Saint-Exupéry
 * id 562F5DDE-E65C-4ACC-98B7-54C0D5406AED
 * name bookshelf
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookshelf.svg
 * tags
 */
export const BookshelfIcon = createSvgIcon(<><path d="M9 3V18H12V3H9M12 5L16 18L19 17L15 4L12 5M5 5V18H8V5H5M3 19V21H21V19H3Z" /></>, 'BookshelfIcon');
export default BookshelfIcon